import React from "react";
import FormattedMessage from "components/FormattedMessage";
import { Text } from "ui-components";
import { VIDEO_ORIENTATIONS } from "utils/constants";
import { isMobile } from "utils/helpers";
import { Box } from "ui-components";

const Video = ({ answer, messageData, videoDirectLink, videoOrientation, metaInfo }) => {

    const videoStyles = metaInfo?.videoOrientation === VIDEO_ORIENTATIONS.PORTRAIT && !isMobile() 
        ? { width: "30%", margin: "0 auto", display: "block" } 
        : { width: "75%", margin: "0 auto", display: "block" };

    return (
    <Box padding={"0.5rem 0.5rem"}>
        <Text padding="0.5rem 1rem" lineHeight={1.5}>
            <FormattedMessage html id={answer} values={messageData} />
        </Text>
        <video style={videoStyles} controls>
            <source src={metaInfo?.videoDirectLink} type="video/mp4" />
            Your browser does not support the videos.
        </video>
    </Box>
    );
};

export default Video;
